/* @flow */
import React, { useState } from 'react';
import {
  StyleSheet, TouchableWithoutFeedback, Platform,
} from 'react-native';
import {
  Text, Surface, Button, Portal, Dialog,
} from 'react-native-paper';
import Icon from 'react-native-vector-icons/FontAwesome';

import { useColors } from '../contexts/theme';
import l from '../utils/localization';


const styles = StyleSheet.create({
  scrollView: { },
  container: {
    margin: 10,
    marginTop: 20,
    borderRadius: 5,
    width: 300,
    alignSelf: 'center',
    elevation: 1,
    padding: 10,
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
  },
  row: {
    flexDirection: 'row', alignItems: 'center', justifyContent: 'space-around', borderBottomWidth: 1,
  },
});

const Wrapper = ({ children }) => Platform.OS === 'web'
  ? (
    <div style={{
      position: 'fixed', height: '100%', width: '100%', pointerEvents: 'none',
    }}
    >
      { children }
    </div>
  )
  : <>{children}</>;

const PremiumInfo = ({ style }) => {
  const [isVisible, setVisible] = useState(false),
        colors = useColors();

  return (
    <>
      <TouchableWithoutFeedback onPress={() => setVisible(true)}>
        <Surface style={[styles.container, {
          backgroundColor: colors.surface,
        }, style]}
        >
          <Icon name='info-circle' color={colors.text} style={{ padding: 10 }} />
          <Text>{l.lysterPremiumComingSoon}</Text>
        </Surface>
      </TouchableWithoutFeedback>
      <Portal>
        <Wrapper>
          <Dialog
            visible={isVisible}
            onDismiss={() => setVisible(false)}
          >
            <Dialog.Title>{l.premium}</Dialog.Title>
            <Dialog.Content>
              <Text>{l.premiumInfo}</Text>
            </Dialog.Content>
            <Dialog.Actions>
              <Button color={colors.text} onPress={() => setVisible(false)}>{l.ok}</Button>
            </Dialog.Actions>
          </Dialog>
        </Wrapper>
      </Portal>
    </>
  );
};

export default PremiumInfo;
